// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { getPinsRequestToJson, getPinsResponseFromJson, setPinsRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function setPins(request) {
    await fetchRpc('atlas.v1.Pins/SetPins', setPinsRequestToJson(request));
}
export function setPins$(request, options) {
    return defer(() => setPinsWithTransport$(getGlobalTransport(), request, options));
}
export function setPinsWithTransport$(transport, request, options) {
    return transport
        .post('atlas.v1.Pins/SetPins', setPinsRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getPins(request) {
    const raw = await fetchRpc('atlas.v1.Pins/GetPins', getPinsRequestToJson(request));
    return getPinsResponseFromJson(raw);
}
export function getPins$(request, options) {
    return defer(() => getPinsWithTransport$(getGlobalTransport(), request, options));
}
export function getPinsWithTransport$(transport, request, options) {
    return transport
        .post('atlas.v1.Pins/GetPins', getPinsRequestToJson(request), options)
        .pipe(map(resp => getPinsResponseFromJson(resp)));
}
